module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "store"
  }, [_c('div', {
    staticClass: "returnBtn",
    on: {
      "click": _vm.returnToLogin
    }
  }, [_c('i', {
    staticClass: "iconfont icon-return"
  }), _vm._v("返回")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "storeListBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请选择你的店铺")]), _vm._v(" "), _c('div', {
    staticClass: "storeScrollBox"
  }, [_c('ul', {
    staticClass: "storeList"
  }, _vm._l((_vm.storeList), function(item, idx) {
    return _c('li', {
      class: {
        active: _vm.curIndex == idx
      },
      on: {
        "mousemove": function($event) {
          _vm.curIndex = idx
        },
        "click": function($event) {
          return _vm.enterSystem(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "addBtn"
  }, [_c('i', {
    staticClass: "iconfont icon-icon02",
    on: {
      "click": function () {
        _vm.$router.push({
          path: '/addStore'
        })
      }
    }
  }), _c('span', {
    on: {
      "click": function () {
        _vm.$router.push({
          path: '/addStore'
        })
      }
    }
  }, [_vm._v("添加店铺")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/login/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("基于云计算SaaS模式")]), _vm._v(" "), _c('p', [_vm._v("收银、营销一体化服务平台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-71959aa9","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/store/store.vue
// module id = 961
// module chunks = 1